import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-liquid-title',
    templateUrl: './liquid-title.component.html',
    styleUrls: ['./liquid-title.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LiquidTitleComponent implements OnInit {
  @Input('text') text: string;
  constructor() {
  }
  
  ngOnInit(): void {
  }
}
